import { useEffect } from "react";

// Plausible loader. Only renders the script tag when VITE_PLAUSIBLE_DOMAIN is set.
// Plausible's default script auto-tracks pushState navigation, so SPA route
// changes are counted without extra wiring.

export default function Analytics() {
  useEffect(() => {
    const domain = import.meta.env.VITE_PLAUSIBLE_DOMAIN;
    if (!domain) return;
    if (document.querySelector('script[data-plausible-loader]')) return;

    const s = document.createElement("script");
    s.defer = true;
    s.setAttribute("data-domain", domain);
    s.setAttribute("data-plausible-loader", "true");
    s.src = "https://plausible.io/js/script.js";
    document.head.appendChild(s);
  }, []);
  return null;
}
